import { motion } from "framer-motion";
import { Instagram, Facebook, Heart, ArrowRight } from "lucide-react";
import { BRAND } from "../lib/constants";

export default function FollowUs() {
  return (
    <section className="bg-white" data-testid="follow-us-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20">
        <div className="grid md:grid-cols-2 gap-5">
          {/* Instagram card */}
          <motion.a
            href={BRAND.instagram}
            target="_blank"
            rel="noreferrer"
            data-testid="follow-instagram"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4 }}
            className="group relative overflow-hidden rounded-3xl p-8 md:p-10 text-white"
            style={{
              background:
                "linear-gradient(135deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%)",
            }}
          >
            <div className="absolute -right-12 -bottom-12 w-56 h-56 rounded-full bg-white/10 blur-2xl pointer-events-none" />
            <div className="relative flex items-start justify-between">
              <div>
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 rounded-2xl bg-white/20 backdrop-blur flex items-center justify-center">
                    <Instagram className="w-6 h-6" />
                  </div>
                  <div>
                    <div className="font-display text-xl font-bold">@hayat.cctv</div>
                    <div className="text-sm text-white/85">5.3K+ followers on Instagram</div>
                  </div>
                </div>
                <p className="mt-6 text-white/90 leading-relaxed max-w-md">
                  CCTV · GPS Trackers · Video Door Phones · Security Systems.
                  Daily posts from live installations across Nagpur.
                </p>
                <div className="mt-6 inline-flex items-center gap-2 text-sm font-semibold">
                  Follow us
                  <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                </div>
              </div>
              <div className="hidden sm:flex flex-col items-center gap-1 text-[11px] font-semibold">
                <Heart className="w-4 h-4" fill="currentColor" />
                #SecureWithHayat
              </div>
            </div>
          </motion.a>

          {/* Facebook card */}
          <motion.a
            href={BRAND.facebook}
            target="_blank"
            rel="noreferrer"
            data-testid="follow-facebook"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4, delay: 0.1 }}
            className="group relative overflow-hidden rounded-3xl p-8 md:p-10 text-white bg-[#1877F2]"
          >
            <div className="absolute -right-10 -top-10 w-52 h-52 rounded-full bg-white/10 blur-2xl pointer-events-none" />
            <div className="relative">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 rounded-2xl bg-white/20 backdrop-blur flex items-center justify-center">
                  <Facebook className="w-6 h-6" />
                </div>
                <div>
                  <div className="font-display text-xl font-bold">Hayat Enterprises</div>
                  <div className="text-sm text-white/85">2.8K+ followers on Facebook</div>
                </div>
              </div>
              <p className="mt-6 text-white/90 leading-relaxed max-w-md">
                Hayat CCTV — expert repair & service solutions. Fast response, genuine parts, affordable charges. Nagpur's trusted CCTV service provider.
              </p>
              <div className="mt-6 inline-flex items-center gap-2 text-sm font-semibold">
                Like our page
                <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
              </div>
            </div>
          </motion.a>
        </div>
      </div>
    </section>
  );
}
